export default {
    // Format number to ARS currency
    fileSize: (value) => {
        if (!value) return ''
        const parts = String(value).split('.')
        return `${parts[0]}.${parts[1].slice(0, 2)}`
    }
}
